import { useApp } from "@/context/AppContext";

export function Logo({ className }: { className?: string }) {
  const { theme } = useApp();

  return (
    <img
      src="/assets/everway-logo.png"
      alt="Everway Logo"
      className={`${className ?? ""} transition-[filter] duration-300 ${
        theme !== "dark" ? "brightness-0 opacity-85" : ""
      }`}
    />
  );
}
